var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWeakness = function SvgWeakness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EC7963"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.4758 10 10 14.4758 10 20C10 25.5242 14.4758 30 20 30C25.5242 30 30 25.5242 30 20C30 14.4758 25.5242 10 20 10ZM15.4839 18.0645C15.4839 17.3508 16.0605 16.7742 16.7742 16.7742C17.4879 16.7742 18.0645 17.3508 18.0645 18.0645C18.0645 18.7782 17.4879 19.3548 16.7742 19.3548C16.0605 19.3548 15.4839 18.7782 15.4839 18.0645ZM20 26.4516C18.5766 26.4516 17.4194 25.2944 17.4194 23.871C17.4194 22.4476 18.5766 21.2903 20 21.2903C21.4234 21.2903 22.5806 22.4476 22.5806 23.871C22.5806 25.2944 21.4234 26.4516 20 26.4516ZM23.2258 19.3548C22.5121 19.3548 21.9355 18.7782 21.9355 18.0645C21.9355 17.3508 22.5121 16.7742 23.2258 16.7742C23.9395 16.7742 24.5161 17.3508 24.5161 18.0645C24.5161 18.7782 23.9395 19.3548 23.2258 19.3548Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeakness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weakness.9f0487a4.svg";
export { ForwardRef as ReactComponent };